import React  from "react";
import AnnouncementTable from "./components/AnnouncementTable";

const Announcements = () => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">      		
	      	<AnnouncementTable />
	      </div>
	    </div>
    );
};

export default Announcements;